import type { ReactNode } from "react";

/** What each lane means, for a popover's foot or a group's tag. */
export const LANE_COPY = {
  instant: "Saves to your draft straight away. You can undo it.",
  requested: "Stax makes this change when you send your comments.",
} as const;

/**
 * The foot of a popover on the page: what happens when the owner confirms it. Instant changes save
 * to the draft now and can be undone; requested ones wait for Stax until comments are sent.
 */
export function LaneNote({ lane, children }: { lane: "instant" | "requested"; children?: ReactNode }) {
  return (
    <p className="bw-lane-note" data-lane={lane}>
      <span className="bw-lane-mark" aria-hidden="true" />
      <span>
        {children ?? LANE_COPY[lane]}
      </span>
    </p>
  );
}
